import type { TaskOccurrenceStatus } from "@dashboard/api/task";

export const OCCURRENCE_STATUS_CONFIG: Record<
    TaskOccurrenceStatus,
    { bg: string; text: string; dot: string; labelKey: string }
> = {
    OPEN: {
        bg: "#fdf0f5",
        text: "#333333",
        dot: "#e86194",
        labelKey: "task.occurrenceStatus.OPEN",
    },
    IN_PROGRESS: {
        bg: "#fff6e0",
        text: "#333333",
        dot: "#ffc000",
        labelKey: "task.occurrenceStatus.IN_PROGRESS",
    },
    BLOCKED: {
        bg: "#f0eee7",
        text: "#666666",
        dot: "#999999",
        labelKey: "task.occurrenceStatus.BLOCKED",
    },
    DONE: {
        bg: "#dff2eb",
        text: "#333333",
        dot: "#7fcdb1",
        labelKey: "task.occurrenceStatus.DONE",
    },
};
